import produce from "immer"
import { QidDatapoint } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initQidDatapoint: QidDatapoint = {
    id: null,
    datapointId: null,
    productId: null,
    modelId: null,
    safetyFunctionId: null,
    optionId: null,
    failureModeId: null,
    versionId: null,
    publicationDate: null,
    sd: null,
    su: null,
    dd: null,
    du: null,
    ne: null,
    np: null,
    datapoints: [],
}

const initQidDatapointState: types.QidDatapointState = {
    datapointList: [],
    datapointDelete: null,

    // edit
    existing: [],
    new: [],
    activeCell: null,
    changes: {},
    deleteExisting: [],

    referenceList: [],

    reloadList: true,
    reloadEdit: true,
}

const qidDatapointReducer = produce((
    draft: types.QidDatapointState = initQidDatapointState,
    action: ActionTypes = null,
): types.QidDatapointState => {
    switch (action.type) {
        case types.QID_DATAPOINT_LIST:
            draft.datapointList = action.datapointList
            return draft

        case types.QID_DATAPOINT_DELETE:
            draft.datapointDelete = action.datapoint
            return draft

        case types.QID_DATAPOINT_EXISTING:
            draft.existing = action.datapoints
            return draft

        case types.QID_DATAPOINT_NEW:
            draft.new = action.datapoints
            return draft

        case types.QID_DATAPOINT_ACTIVE_CELL:
            draft.activeCell = action.cell
            return draft

        case types.QID_DATAPOINT_CHANGES:
            draft.changes = action.changes
            return draft

        case types.QID_DATAPOINT_DELETE_EXISTING:
            draft.deleteExisting = action.datapointIds
            return draft

        case types.QID_DATAPOINT_REFERENCE_LIST:
            draft.referenceList = action.referenceList
            return draft

        case types.QID_DATAPOINT_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.QID_DATAPOINT_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default qidDatapointReducer
